import { NavigationGuard } from "vue-router";
import store from "@/store";
import { GROUP_ROUTE_MAP } from "@/utils/consts";

export const redirectToGroupPage: NavigationGuard = (to, from, next) => {
    const state: any = store.state;

    if (state.auth.user.groups.length === 1) {
        next({
            name: GROUP_ROUTE_MAP[state.auth.user.groups[0]]
        });
    } else {
        next();
    }
};
